import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum PROVIDER_FORM_FIELDS {
  NAME ='Name',
  IS_SANDBOX = 'sandbox',
  IS_ACTIVE = 'isActive',
  MCC = 'Mcc',
  PROCESSOR_ID = 'processorId',
  PARTNER_ID = 'PartnerId',
  PROCESSOR_PLATFORM = 'ProcessorPlatform',
  // META_ID = 'metaId',
  // MC_DESCRIPTOR_PREFIX = 'masterCardDescriptorPrefix',
  // VISA_DESCRIPTOR_PREFIX = 'visaDescriptorPrefix',

  // Capabilities

  CARD_BRANDS = 'CardBrands',
  SUPPORT_3DS = 'CapabilitiesSupport3DS',
  SUPPORT_3DS2 = 'CapabilitiesSupport3DS2',
  SUPPORTED_COUNTRIES = 'CapabilitiesSupportedCountries',
  SUPPORTED_CURRENCIES = 'CapabilitiesSupportedCurrencies',
  SUPPORT_CIT = 'CapabilitiesSupportCIT',
  SUPPORT_MIT = 'CapabilitiesSupportMIT',
  USE_DYNAMIC_DESCRIPTOR = 'CapabilitiesUseDynamicDescriptor',
  USE_DEFAULT_DUP_CHECK_SECONDS = 'CapabilitiesUseDefaultDupCheckSeconds',
  USE_DESCRIPTOR_SUFFIX = 'CapabilitiesUseDescriptorSuffix',
  SUPPORT_TOKENIZATION = 'CapabilitiesSupportTokenization',
  SUPPORT_NETWORK_TOKENIZATION = 'CapabilitiesSupportNetworkTokenization',
  SUPPORT_NETWORK_TOKENIZATION_3DS = 'CapabilitiesSupportNetworkTokenization3DS',
  SUPPORT_STANDALONE_REFUND = 'SupportStandaloneRefund',
  SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT = 'SupportExternalNetworkTokenPayment',

  // Configurations

  SECRET_KEY = 'ConfigurationSecretKey',
  USER = 'ConfigurationUser',
  PASSWORD = 'ConfigurationPassword',
  ACCOUNT_ID = 'ConfigurationAccountId',
  ACCESS_KEY = 'ConfigurationAccessKey',
  WALLET_ID = 'ConfigurationWalletId',
  BALANCE_CURRENCY = 'ConfigurationBalanceCurrency',
  PROCESSING_CHANNEL_ID = 'ConfigurationProcessingChannelId',
  PUBLIC_KEY = 'ConfigurationPublicKey',
  CONFIG_SUPPORTED_CURRENCIES = 'ConfigurationSupportedCurrencies',

  CLIENT_ID = 'configurationClientId',
  STATIC_KEY = 'configurationStaticKey',
  WEBHOOK_URL = 'configurationWebhookUrl',
  WEBHOOK_SECRET = 'configurationWebhookSecret',
  PROCESSOR = 'configurationProcessor',
  ACCOUNT_UPDATER_PRIVATE_KEY = 'configurationAccountUpdaterPrivateKey',

  MERCHANT_ACCOUNT = 'ConfigurationMerchantAccount',
  API_KEY = 'ConfigurationApiKey',
  CONFIG_MCC = 'ConfigurationMcc',
  WEBHOOK_HMAC_KEY = 'ConfigurationHmacKey',

  APP_NAME = 'ConfigurationAppName',
  APP_VERSION = 'ConfigurationAppVersion',

  MERCHANT_ID = 'merchantId',
  LOGIN = 'login',

  PRIVATE_KEY = 'ConfigurationPrivateKey',
}

export enum PROVIDER_FORM_FIELD_NAMES {
  NAME = 'PROVIDER.LABELS.NAME',
  IS_SANDBOX = 'PROVIDER.LABELS.IS_SANDBOX',
  IS_ACTIVE = 'PROVIDER.LABELS.IS_ACTIVE',
  MCC = 'PROVIDER.LABELS.MCC',
  PROCESSOR_ID = 'PROVIDER.LABELS.PROCESSOR_ID',
  PARTNER_ID = 'PROVIDER.LABELS.PARTNER_ID',
  META_ID = 'PROVIDER.LABELS.META_ID',
  MC_DESCRIPTOR_PREFIX = 'PROVIDER.LABELS.MC_DESCRIPTOR_PREFIX',
  VISA_DESCRIPTOR_PREFIX = 'PROVIDER.LABELS.VISA_DESCRIPTOR_PREFIX',
  PROCESSOR_PLATFORM = 'PROVIDER.LABELS.PROCESSOR_PLATFORM',

  // Capabilities

  CARD_BRANDS = 'PROVIDER.LABELS.CARD_BRANDS',
  SUPPORT_3DS = 'PROVIDER.LABELS.SUPPORT_3DS',
  SUPPORT_3DS2 = 'PROVIDER.LABELS.SUPPORT_3DS2',
  SUPPORT_CIT = 'PROVIDER.LABELS.SUPPORT_CIT',
  SUPPORTED_COUNTRIES = 'PROVIDER.LABELS.SUPPORTED_COUNTRIES',
  SUPPORTED_CURRENCIES = 'PROVIDER.LABELS.SUPPORTED_CURRENCIES',
  SUPPORT_MIT = 'PROVIDER.LABELS.SUPPORT_MIT',
  USE_DYNAMIC_DESCRIPTOR = 'PROVIDER.LABELS.USE_DYNAMIC_DESCRIPTOR',
  USE_DEFAULT_DUP_CHECK_SECONDS = 'PROVIDER.LABELS.USE_DEFAULT_DUP_CHECK_SECONDS',
  USE_DESCRIPTOR_SUFFIX = 'PROVIDER.LABELS.USE_DESCRIPTOR_SUFFIX',
  SUPPORT_TOKENIZATION = 'PROVIDER.LABELS.SUPPORT_TOKENIZATION',
  SUPPORT_NETWORK_TOKENIZATION = 'PROVIDER.LABELS.SUPPORT_NETWORK_TOKENIZATION',
  SUPPORT_NETWORK_TOKENIZATION_3DS = 'PROVIDER.LABELS.SUPPORT_NETWORK_TOKENIZATION_3DS',
  MC_MONTHLY_MAX_TRANSACTIONS_COUNT = 'PROVIDER.LABELS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT',
  MC_MONTHLY_MAX_VALUE = 'PROVIDER.LABELS.MC_MONTHLY_MAX_VALUE',
  SUPPORT_STANDALONE_REFUND = 'PROVIDER.LABELS.SUPPORT_STANDALONE_REFUND',
  SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT = 'PROVIDER.LABELS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT',

  // Configurations

  SECRET_KEY = 'PROVIDER.LABELS.SECRET_KEY',
  USER = 'PROVIDER.LABELS.USER',
  PASSWORD = 'PROVIDER.LABELS.PASSWORD',
  ACCOUNT_ID = 'PROVIDER.LABELS.ACCOUNT_ID',
  ACCESS_KEY = 'PROVIDER.LABELS.ACCESS_KEY',
  WALLET_ID = 'PROVIDER.LABELS.WALLET_ID',
  BALANCE_CURRENCY = 'PROVIDER.LABELS.BALANCE_CURRENCY',
  PROCESSING_CHANNEL_ID = 'PROVIDER.LABELS.PROCESSING_CHANNEL_ID',
  PUBLIC_KEY = 'PROVIDER.LABELS.PUBLIC_KEY',
  CONFIG_SUPPORTED_CURRENCIES = 'PROVIDER.LABELS.SUPPORTED_CURRENCIES',
  ACCOUNT_UPDATER_PRIVATE_KEY = 'PROVIDER.LABELS.ACCOUNT_UPDATER_PRIVATE_KEY',
  CLIENT_ID = 'PROVIDER.LABELS.CLIENT_ID',
  STATIC_KEY = 'PROVIDER.LABELS.STATIC_KEY',
  WEBHOOK_URL = 'PROVIDER.LABELS.WEBHOOK_URL',
  WEBHOOK_SECRET = 'PROVIDER.LABELS.WEBHOOK_SECRET',
  PROCESSOR = 'PROVIDER.LABELS.PROCESSOR',
  MERCHANT_ACCOUNT = 'PROVIDER.LABELS.MERCHANT_ACCOUNT',
  API_KEY = 'PROVIDER.LABELS.API_KEY',
  CONFIG_MCC = 'PROVIDER.LABELS.CONFIG_MCC',
  WEBHOOK_HMAC_KEY = 'PROVIDER.LABELS.WEBHOOK_HMAC_KEY',
  APP_NAME = 'PROVIDER.LABELS.APP_NAME',
  APP_VERSION = 'PROVIDER.LABELS.APP_VERSION',
  MERCHANT_ID = 'PROVIDER.LABELS.MERCHANT_ID',
  LOGIN = 'PROVIDER.LABELS.LOGIN',
  PRIVATE_KEY = 'PROVIDER.LABELS.PRIVATE_KEY',
}

export type providerFormTypes = {
  [PROVIDER_FORM_FIELDS.NAME]: string,
  [PROVIDER_FORM_FIELDS.IS_SANDBOX]: boolean,
  [PROVIDER_FORM_FIELDS.IS_ACTIVE]: boolean,
  [PROVIDER_FORM_FIELDS.MCC]: string,
  [PROVIDER_FORM_FIELDS.PROCESSOR_ID]: string,
  [PROVIDER_FORM_FIELDS.PARTNER_ID]: string,
  [PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM]: string,
  // [PROVIDER_FORM_FIELDS.META_ID]: string,
  // [PROVIDER_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: string,
  // [PROVIDER_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: string,

  // Capabilities

  [PROVIDER_FORM_FIELDS.CARD_BRANDS]: string[],
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS2]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_CIT]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES]: string[],
  [PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES]: string[],
  [PROVIDER_FORM_FIELDS.SUPPORT_MIT]: boolean,
  [PROVIDER_FORM_FIELDS.USE_DYNAMIC_DESCRIPTOR]: boolean,
  // [PROVIDER_FORM_FIELDS.CARD_TYPES]: string,
  // [PROVIDER_FORM_FIELDS.PAYMENT_METHODS]: string,
  // [PROVIDER_FORM_FIELDS.PAYMENT_TYPES]: string,
  [PROVIDER_FORM_FIELDS.USE_DEFAULT_DUP_CHECK_SECONDS]: boolean,
  [PROVIDER_FORM_FIELDS.USE_DESCRIPTOR_SUFFIX]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_TOKENIZATION]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION_3DS]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_STANDALONE_REFUND]: boolean,
  [PROVIDER_FORM_FIELDS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT]: boolean,
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: string,
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_VALUE]: string,

  // Configurations

  [PROVIDER_FORM_FIELDS.SECRET_KEY]?: string,
  [PROVIDER_FORM_FIELDS.USER]?: string,
  [PROVIDER_FORM_FIELDS.PASSWORD]?: string,
  [PROVIDER_FORM_FIELDS.ACCOUNT_ID]?: string,
  [PROVIDER_FORM_FIELDS.WALLET_ID]?: string,
  [PROVIDER_FORM_FIELDS.ACCESS_KEY]?: string,
  [PROVIDER_FORM_FIELDS.BALANCE_CURRENCY]?: string,
  [PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID]?: string,
  [PROVIDER_FORM_FIELDS.PUBLIC_KEY]?: string,
  [PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES]?: string[],
  [PROVIDER_FORM_FIELDS.CLIENT_ID]?: string,
  [PROVIDER_FORM_FIELDS.STATIC_KEY]?: string,
  [PROVIDER_FORM_FIELDS.WEBHOOK_URL]?: string,
  [PROVIDER_FORM_FIELDS.WEBHOOK_SECRET]?: string,
  [PROVIDER_FORM_FIELDS.PROCESSOR]?: string,
  [PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY]?: string,
  [PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT]?: string,
  [PROVIDER_FORM_FIELDS.API_KEY]?: string,
  [PROVIDER_FORM_FIELDS.CONFIG_MCC]?: string,
  [PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY]?: string,
  [PROVIDER_FORM_FIELDS.APP_NAME]?: string,
  [PROVIDER_FORM_FIELDS.APP_VERSION]?: string,
  [PROVIDER_FORM_FIELDS.MERCHANT_ID]?: string,
  [PROVIDER_FORM_FIELDS.LOGIN]?: string,
  [PROVIDER_FORM_FIELDS.PRIVATE_KEY]?: string,
}

export type providerFormReturnTypes = {
  name: string,
  sandbox: boolean,
  isActive: boolean,
  mcc: string,
  processorId: string,
  partnerId: string,
  processorPlatform: string,
  // metaId: string,
  // authenticationType: string,
  // masterCardDescriptorPrefix: string,
  // visaDescriptorPrefix: string,

  // Capabilities
  capabilities: {
    cardBrands: string[],
    support3DS: boolean,
    support3DS2: boolean,
    supportCIT: boolean,
    supportedCountries: string[],
    supportedCurrencies: string[],
    supportMIT: boolean,
    useDynamicDescriptor: boolean,
    useDefaultDupCheckSeconds: boolean,
    useDescriptorSuffix: boolean,
    supportTokenization: boolean,
    supportNetworkTokenization: boolean,
    supportNetworkTokenization3DS: boolean,
    supportStandaloneRefund: boolean,
    supportExternalNetworkTokenPayment: boolean,
    // masterCardMonthlyMaxTransactionsCount: string,
    // masterCardMonthlyMaxValue: string,
  },

  // Configurations
  configuration?: {
    secretKey?: string,
    user?: string,
    password?: string,
    accountId?: string,
    accessKey?: string,
    walletId?: string,
    balanceCurrency?: string,
    supportedCurrencies?: string[],
    processingChannelId?: string,
    publicKey?: string,
    accountUpdaterPrivateKey?: string,
    clientId?: string,
    staticKey?: string,
    webhookUrl?: string,
    webhookSecret?: string,
    processor?: string,
    merchantAccount?: string,
    apiKey?: string,
    mcc?: string,
    webhookHmacKey?: string,
    appName?: string,
    appVersion?: string,
    merchantId?: string,
    login?: string,
    privateKey?: string,
  }
}

export const providerFormInitialValues: providerFormTypes = {
  [PROVIDER_FORM_FIELDS.NAME]: '',
  [PROVIDER_FORM_FIELDS.IS_SANDBOX]: false,
  [PROVIDER_FORM_FIELDS.IS_ACTIVE]: true,
  [PROVIDER_FORM_FIELDS.MCC]: '',
  [PROVIDER_FORM_FIELDS.PROCESSOR_ID]: '',
  [PROVIDER_FORM_FIELDS.PARTNER_ID]: '',
  [PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM]: '',
  // [PROVIDER_FORM_FIELDS.META_ID]: 'F24f18c1-D2bb-7eBA-beF7-e26fDe2Ffb65',
  // [PROVIDER_FORM_FIELDS.AUTHENTICATION_TYPE]: '',
  // [PROVIDER_FORM_FIELDS.MC_DESCRIPTOR_PREFIX]: '',
  // [PROVIDER_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX]: '',

  // Capabilities

  [PROVIDER_FORM_FIELDS.CARD_BRANDS]: [],
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS]: true,
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS2]: true,
  [PROVIDER_FORM_FIELDS.SUPPORT_CIT]: true,
  [PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES]: [],
  [PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES]: [],
  [PROVIDER_FORM_FIELDS.SUPPORT_MIT]: true,
  [PROVIDER_FORM_FIELDS.USE_DYNAMIC_DESCRIPTOR]: true,
  [PROVIDER_FORM_FIELDS.USE_DEFAULT_DUP_CHECK_SECONDS]: false,
  [PROVIDER_FORM_FIELDS.USE_DESCRIPTOR_SUFFIX]: false,
  [PROVIDER_FORM_FIELDS.SUPPORT_TOKENIZATION]: true,
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION]: false,
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION_3DS]: true,
  [PROVIDER_FORM_FIELDS.SUPPORT_STANDALONE_REFUND]: false,
  [PROVIDER_FORM_FIELDS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT]: false,
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: '',
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_VALUE]: '',

  // Configurations

  [PROVIDER_FORM_FIELDS.SECRET_KEY]: '',
  [PROVIDER_FORM_FIELDS.USER]: '',
  [PROVIDER_FORM_FIELDS.PASSWORD]: '',
  [PROVIDER_FORM_FIELDS.ACCOUNT_ID]: '',
  [PROVIDER_FORM_FIELDS.WALLET_ID]: '',
  [PROVIDER_FORM_FIELDS.ACCESS_KEY]: '',
  [PROVIDER_FORM_FIELDS.BALANCE_CURRENCY]: '',
  [PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID]: '',
  [PROVIDER_FORM_FIELDS.PUBLIC_KEY]: '',
  [PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES]: [],
  [PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY]: '',
  [PROVIDER_FORM_FIELDS.CLIENT_ID]: '',
  [PROVIDER_FORM_FIELDS.STATIC_KEY]: '',
  [PROVIDER_FORM_FIELDS.WEBHOOK_URL]: '',
  [PROVIDER_FORM_FIELDS.WEBHOOK_SECRET]: '',
  [PROVIDER_FORM_FIELDS.PROCESSOR]: '',
  [PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT]: '',
  [PROVIDER_FORM_FIELDS.API_KEY]: '',
  [PROVIDER_FORM_FIELDS.CONFIG_MCC]: '',
  [PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY]: '',
  [PROVIDER_FORM_FIELDS.APP_NAME]: '',
  [PROVIDER_FORM_FIELDS.APP_VERSION]: '',
  [PROVIDER_FORM_FIELDS.MERCHANT_ID]: '',
  [PROVIDER_FORM_FIELDS.LOGIN]: '',
  [PROVIDER_FORM_FIELDS.PRIVATE_KEY]: '',
};

export enum PROVIDER {
  ADYEN = 'adyen',
  BRAINTREE = 'braintree',
  CHECKOUT = 'checkout',
  NMI = 'nmi',
  RAPYD = 'rapyd',
  PAYSAFE = 'paysafe',
  REVOLV3 = 'revolv3',
  STRIPE = 'stripe',
  USIO = 'usio',
}

export const getProviderFormValidationSchema = (t: TFunction, providerName: string): any => {
  switch (providerName.toLowerCase()) {
    case PROVIDER.ADYEN:
      return getAdyenProviderFormValidationSchema(t);
    case PROVIDER.BRAINTREE:
      return getBraintreeProviderFormValidationSchema(t);
    case PROVIDER.CHECKOUT:
      return getCheckoutProviderFormValidationSchema(t);
    case PROVIDER.NMI:
      return getNmiProviderFormValidationSchema(t);
    case PROVIDER.PAYSAFE:
      return getPaysafeProviderFormValidationSchema(t);
    case PROVIDER.RAPYD:
      return getRapydProviderFormValidationSchema(t);
    case PROVIDER.REVOLV3:
      return getRevolv3ProviderFormValidationSchema(t);
    case PROVIDER.STRIPE:
      return getStripeProviderFormValidationSchema(t);
    case PROVIDER.USIO:
      return getUsioProviderFormValidationSchema(t);
    default:
      return getMainProviderFormValidationSchema(t);
  }
};
  //@ts-ignore
export const getMainProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  [PROVIDER_FORM_FIELDS.PARTNER_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PARTNER_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PROCESSOR_ID]: Yup.string(),
  [PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PROCESSOR_PLATFORM_REQUIRED')),
  [PROVIDER_FORM_FIELDS.NAME]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.NAME_REQUIRED')),
  [PROVIDER_FORM_FIELDS.MCC]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.MCC_REQUIRED')),
  [PROVIDER_FORM_FIELDS.IS_SANDBOX]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.IS_ACTIVE]: Yup.boolean(),

  // Capabilities

  [PROVIDER_FORM_FIELDS.CARD_BRANDS]: Yup.array()
    .min(1, t('PROVIDER.VALIDATIONS.CARD_BRANDS_REQUIRED'))
    .required(t('PROVIDER.VALIDATIONS.CARD_BRANDS_REQUIRED')),
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_3DS2]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES]: Yup.array()
    .min(1, t('PROVIDER.VALIDATIONS.SUPPORTED_COUNTRIES_REQUIRED'))
    .required(t('PROVIDER.VALIDATIONS.SUPPORTED_COUNTRIES_REQUIRED')),
  [PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES]: Yup.array()
    .min(1, t('PROVIDER.VALIDATIONS.SUPPORTED_CURRENCIES_REQUIRED'))
    .required(t('PROVIDER.VALIDATIONS.SUPPORTED_CURRENCIES_REQUIRED')),
  [PROVIDER_FORM_FIELDS.SUPPORT_CIT]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_MIT]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.USE_DYNAMIC_DESCRIPTOR]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.USE_DEFAULT_DUP_CHECK_SECONDS]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.USE_DESCRIPTOR_SUFFIX]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_TOKENIZATION]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION_3DS]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_STANDALONE_REFUND]: Yup.boolean(),
  [PROVIDER_FORM_FIELDS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT]: Yup.boolean(),
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]: Yup.string(),
  // [PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_VALUE]: Yup.string(),
});

export const getCheckoutProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PROCESSING_CHANNEL_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PUBLIC_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PUBLIC_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.SECRET_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.SECRET_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY]: Yup.string()

});
export const getNmiProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.SECRET_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.SECRET_KEY_REQUIRED')),
});
export const getRapydProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.ACCESS_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.ACCESS_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.BALANCE_CURRENCY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.BALANCE_CURRENCY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.SECRET_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.SECRET_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.WALLET_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.WALLET_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES]: Yup.array()
    .min(1, t('PROVIDER.VALIDATIONS.SUPPORTED_CURRENCIES_REQUIRED'))
    .required(t('PROVIDER.VALIDATIONS.SUPPORTED_CURRENCIES_REQUIRED')),
  [PROVIDER_FORM_FIELDS.BALANCE_CURRENCY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.BALANCE_CURRENCY_REQUIRED')),
});
export const getPaysafeProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.USER]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.USER_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PASSWORD]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PASSWORD_REQUIRED')),
  [PROVIDER_FORM_FIELDS.ACCOUNT_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.ACCOUNT_ID_REQUIRED')),
});
export const getRevolv3ProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.SECRET_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.SECRET_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.CLIENT_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.CLIENT_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.STATIC_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.STATIC_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.WEBHOOK_URL]: Yup.string()
    .url(t('PROVIDER.VALIDATIONS.WEBHOOK_URL_VALIDATION')),
    // .required(t('PROVIDER.VALIDATIONS.WEBHOOK_URL_REQUIRED')),
  [PROVIDER_FORM_FIELDS.WEBHOOK_SECRET]: Yup.string(),
    // .required(t('PROVIDER.VALIDATIONS.WEBHOOK_SECRET_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PROCESSOR]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PROCESSOR_REQUIRED')),
});

export const getAdyenProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.MERCHANT_ACCOUNT_REQUIRED')),
  [PROVIDER_FORM_FIELDS.API_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.API_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.CONFIG_MCC]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.CONFIG_MCC_REQUIRED')),
  [PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.WEBHOOK_HMAC_KEY_REQUIRED')),
});

export const getBraintreeProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.MERCHANT_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.MERCHANT_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PUBLIC_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PUBLIC_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PRIVATE_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PRIVATE_KEY_REQUIRED')),
});
export const getStripeProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.WEBHOOK_SECRET]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.MERCHANT_ACCOUNT_REQUIRED')),
  [PROVIDER_FORM_FIELDS.API_KEY]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.API_KEY_REQUIRED')),
  [PROVIDER_FORM_FIELDS.CLIENT_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.CLIENT_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.APP_NAME]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.APP_NAME_REQUIRED')),
  [PROVIDER_FORM_FIELDS.APP_VERSION]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.APP_VERSION_REQUIRED')),
});

export const getUsioProviderFormValidationSchema = (t: TFunction): Yup.SchemaOf<providerFormTypes> => Yup.object<Shape<providerFormTypes>>().shape({
  ...getMainProviderFormValidationSchema(t).fields,
  [PROVIDER_FORM_FIELDS.MERCHANT_ID]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.MERCHANT_ID_REQUIRED')),
  [PROVIDER_FORM_FIELDS.LOGIN]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.LOGIN_REQUIRED')),
  [PROVIDER_FORM_FIELDS.PASSWORD]: Yup.string()
    .required(t('PROVIDER.VALIDATIONS.PASSWORD_REQUIRED')),
});



export const getFormattedMainProviderFields = (formikValues): providerFormReturnTypes => ({
  name: formikValues[PROVIDER_FORM_FIELDS.NAME],
  sandbox: formikValues[PROVIDER_FORM_FIELDS.IS_SANDBOX],
  isActive: formikValues[PROVIDER_FORM_FIELDS.IS_ACTIVE],
  mcc: formikValues[PROVIDER_FORM_FIELDS.MCC],
  processorId: formikValues[PROVIDER_FORM_FIELDS.PROCESSOR_ID] ? formikValues[PROVIDER_FORM_FIELDS.PROCESSOR_ID] : null,
  processorPlatform: formikValues[PROVIDER_FORM_FIELDS.PROCESSOR_PLATFORM],
  partnerId: formikValues[PROVIDER_FORM_FIELDS.PARTNER_ID],
  // metaId: formikValues[PROVIDER_FORM_FIELDS.META_ID],
  // masterCardDescriptorPrefix: formikValues[PROVIDER_FORM_FIELDS.MC_DESCRIPTOR_PREFIX],
  // visaDescriptorPrefix: formikValues[PROVIDER_FORM_FIELDS.VISA_DESCRIPTOR_PREFIX],
  capabilities: {
    cardBrands: formikValues[PROVIDER_FORM_FIELDS.CARD_BRANDS],
    support3DS: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_3DS],
    support3DS2: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_3DS2],
    supportCIT: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_CIT],
    supportedCountries: formikValues[PROVIDER_FORM_FIELDS.SUPPORTED_COUNTRIES],
    supportedCurrencies: formikValues[PROVIDER_FORM_FIELDS.SUPPORTED_CURRENCIES],
    supportMIT: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_MIT],
    useDynamicDescriptor: formikValues[PROVIDER_FORM_FIELDS.USE_DYNAMIC_DESCRIPTOR],
    useDefaultDupCheckSeconds: formikValues[PROVIDER_FORM_FIELDS.USE_DEFAULT_DUP_CHECK_SECONDS],
    useDescriptorSuffix: formikValues[PROVIDER_FORM_FIELDS.USE_DESCRIPTOR_SUFFIX],
    supportTokenization: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_TOKENIZATION],
    supportNetworkTokenization: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION],
    supportNetworkTokenization3DS: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_NETWORK_TOKENIZATION_3DS],
    supportStandaloneRefund: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_STANDALONE_REFUND],
    supportExternalNetworkTokenPayment: formikValues[PROVIDER_FORM_FIELDS.SUPPORT_EXTERNAL_NETWORK_TOKEN_PAYMENT],
    // masterCardMonthlyMaxTransactionsCount: formikValues[PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT],
    // masterCardMonthlyMaxValue: formikValues[PROVIDER_FORM_FIELDS.MC_MONTHLY_MAX_VALUE],
  },
});

export const getFormattedCheckoutProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    processingChannelId: formikValues[PROVIDER_FORM_FIELDS.PROCESSING_CHANNEL_ID],
    publicKey: formikValues[PROVIDER_FORM_FIELDS.PUBLIC_KEY],
    secretKey: formikValues[PROVIDER_FORM_FIELDS.SECRET_KEY],
    accountUpdaterPrivateKey: formikValues[PROVIDER_FORM_FIELDS.ACCOUNT_UPDATER_PRIVATE_KEY],
  },
});

export const getFormattedNmiProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    secretKey: formikValues[PROVIDER_FORM_FIELDS.SECRET_KEY],
  },
});

export const getFormattedRapydProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    accessKey: formikValues[PROVIDER_FORM_FIELDS.ACCESS_KEY],
    balanceCurrency: formikValues[PROVIDER_FORM_FIELDS.BALANCE_CURRENCY],
    secretKey: formikValues[PROVIDER_FORM_FIELDS.SECRET_KEY],
    walletId: formikValues[PROVIDER_FORM_FIELDS.WALLET_ID],
    supportedCurrencies: formikValues[PROVIDER_FORM_FIELDS.CONFIG_SUPPORTED_CURRENCIES],
  },
});

export const getFormattedPaysafeProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    user: formikValues[PROVIDER_FORM_FIELDS.USER],
    password: formikValues[PROVIDER_FORM_FIELDS.PASSWORD],
    accountId: formikValues[PROVIDER_FORM_FIELDS.ACCOUNT_ID],
  },
});

export const getFormattedRevolv3ProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    clientId: formikValues[PROVIDER_FORM_FIELDS.CLIENT_ID],
    staticKey: formikValues[PROVIDER_FORM_FIELDS.STATIC_KEY],
    secretKey: formikValues[PROVIDER_FORM_FIELDS.SECRET_KEY],
    webhookUrl: formikValues[PROVIDER_FORM_FIELDS.WEBHOOK_URL],
    webhookSecret: formikValues[PROVIDER_FORM_FIELDS.WEBHOOK_SECRET],
    processor: formikValues[PROVIDER_FORM_FIELDS.PROCESSOR],
  },
});

export const getFormattedAdyenProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    merchantAccount: formikValues[PROVIDER_FORM_FIELDS.MERCHANT_ACCOUNT],
    apiKey: formikValues[PROVIDER_FORM_FIELDS.API_KEY],
    mcc: formikValues[PROVIDER_FORM_FIELDS.CONFIG_MCC],
    webhookHmacKey: formikValues[PROVIDER_FORM_FIELDS.WEBHOOK_HMAC_KEY],
  },
});

export const getFormattedBraintreeProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    merchantId: formikValues[PROVIDER_FORM_FIELDS.MERCHANT_ID],
    publicKey: formikValues[PROVIDER_FORM_FIELDS.PUBLIC_KEY],
    privateKey: formikValues[PROVIDER_FORM_FIELDS.PRIVATE_KEY],
  },
});

export const getFormattedStripeProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    webhookSecret: formikValues[PROVIDER_FORM_FIELDS.WEBHOOK_SECRET],
    apiKey: formikValues[PROVIDER_FORM_FIELDS.API_KEY],
    clientId: formikValues[PROVIDER_FORM_FIELDS.CLIENT_ID],
    appName: formikValues[PROVIDER_FORM_FIELDS.APP_NAME],
    appVersion: formikValues[PROVIDER_FORM_FIELDS.APP_VERSION],
  },
});

export const getFormattedUsioProviderFields = (formikValues): providerFormReturnTypes => ({
  ...getFormattedMainProviderFields(formikValues),
  configuration: {
    merchantId: formikValues[PROVIDER_FORM_FIELDS.MERCHANT_ID],
    login: formikValues[PROVIDER_FORM_FIELDS.LOGIN],
    password: formikValues[PROVIDER_FORM_FIELDS.PASSWORD]
  },
});
